import React from 'react';
import Hero from '../components/homePage/Hero';
import Countdown from '../components/homePage/Countdown';
import AboutSection from '../components/homePage/AboutSection';
import ProgramHighlight from '../components/homePage/ProgramHighlight';
import ImportantDates from '../components/homePage/ImportantDates';
import TopicsSection from '../components/homePage/TopicsSection';
import OrganizersSection from '../components/homePage/OrganizersSection';
import SponsorsSection from '../components/homePage/SponsorsSection';
import AcceptedSessionsSection from '../components/homePage/AcceptedSessionsSection';


const HomePage = () => {
    return (
        <>
        <Hero />
        <div style={{ position: 'relative', width: '100%' }}>
          <Countdown />
        </div>
        <AboutSection />
        <ProgramHighlight />
        <ImportantDates />
        <AcceptedSessionsSection />
        <hr className="custom-hr" />
        <TopicsSection />
        <hr className="custom-hr" />
        <OrganizersSection />
        <SponsorsSection />
        </>
    );
};

export default HomePage;